import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 登頁PostBack
 */
const LoginPostBack = [
    'POST',
    RouteUrlList.API_LoginPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];

export default LoginPostBack;
